"use client";
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as e } from "react/jsx-runtime";
import { useTheme as h } from "../../hooks.js";
import { useIsInverseVariant as c } from "../../theme-variant-context.js";
import { vars as o } from "../../skins/skin-contract.css-mistica.js";
const s = (_param)=>{
    var { color: i, size: l = 24 } = _param, a = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const n = c(), r = i !== null && i !== void 0 ? i : n ? o.colors.inverse : o.colors.neutralHigh, { skinName: t } = h();
    return t.match(/^blau/i) ? /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: l,
        height: l,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, a), {
        children: /* @__PURE__ */ e("path", {
            fill: r,
            d: "m20.37 5.633-1.456 1.453-2.033-2.03 1.455-1.453a.84.84 0 0 1 1.154 0l.88.878a.815.815 0 0 1 0 1.152M8.411 17.57l-2.033-2.03 9.535-9.518 2.033 2.03zM4.35 19.624 5.504 16.6l1.865 1.863zm16.988-16.11-.879-.877A2.17 2.17 0 0 0 18.914 2c-.585 0-1.134.226-1.546.637L4.443 15.542 1.976 22l6.435-2.496L21.337 6.599a2.18 2.18 0 0 0 0-3.085"
        })
    })) : t.match(/^o2-new/i) ? /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: l,
        height: l,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, a), {
        children: /* @__PURE__ */ e("path", {
            fill: r,
            d: "M15.533 3.107a3.79 3.79 0 0 1 5.364 5.353L9.157 20.205a.73.73 0 0 1-.388.2l-5.856 1.572a.723.723 0 0 1-.888-.884l1.588-5.926a.7.7 0 0 1 .228-.364zM4.681 16.751l-.936 3.505 3.5-.94zm3.964 1.916 9.992-9.994-3.312-3.313-9.992 9.994zM19.657 7.652l.212-.212c.912-.912.912-2.4 0-3.312a2.346 2.346 0 0 0-3.312 0l-.212.212z"
        })
    })) : t.match(/^o2/i) ? /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: l,
        height: l,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, a), {
        children: /* @__PURE__ */ e("path", {
            fill: r,
            d: "M15.533 3.107a3.79 3.79 0 0 1 5.364 5.353L9.157 20.205a.73.73 0 0 1-.388.2l-5.856 1.572a.723.723 0 0 1-.888-.884l1.588-5.926a.7.7 0 0 1 .228-.364zM4.681 16.751l-.936 3.505 3.5-.94zm3.964 1.916 9.992-9.994-3.312-3.313-9.992 9.994zM19.657 7.652l.212-.212c.912-.912.912-2.4 0-3.312a2.346 2.346 0 0 0-3.312 0l-.212.212z"
        })
    })) : /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: l,
        height: l,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, a), {
        children: /* @__PURE__ */ e("path", {
            fill: r,
            d: "M20.342 3.399q.127.122.249.249c1.339 1.39 2.011 3.622-.115 5.731L9.232 20.556l-.01.008-.01.008-.003.006-.005.006q-.026.024-.06.041l-.03.017-.021.014-.015.009a.6.6 0 0 1-.305.095q-.008 0-.015-.003l-.016-.003-5.868 1.079a.62.62 0 0 1-.532-.16.59.59 0 0 1-.18-.524l.942-6.1a.3.3 0 0 1 .016-.05l.012-.035a1 1 0 0 1 .02-.067.5.5 0 0 1 .122-.179l11.309-11.19c2.154-2.132 4.386-1.463 5.759-.13M18.944 9.19l.666-.663c1.85-1.83.687-3.44.104-4.048-.067-.07-.148-.151-.221-.224-.6-.58-2.185-1.726-4.048.12l-.683.678zM4.639 20.284l-.967-.958-.182 1.168zm1.61-3.473 9.336-9.239-1.683-1.666-9.34 9.238zM3.9 17.85l2.19 2.168 1.415-.26L4.12 16.41zm4.871 1.456s9.314-9.26 9.311-9.26l-1.639-1.622-9.336 9.238z"
        })
    }));
}, v = s;
export { v as default };
